export default function removeClasses() {
  var swiper = this;
  var $el = swiper.$el,
      classNames = swiper.classNames;
  $el.removeClass(classNames.join(' '));
  swiper.emitContainerClasses();
}


//////////////////
// WEBPACK FOOTER
// /Users/izizac/Desktop/Biurko — MacBook Pro (Maciej)/sage/node_modules/swiper/esm/components/core/classes/removeClasses.js
// module id = 78
// module chunks = 0